/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 */
export * from '../generated/YGEnums';
export type { Config, DirtiedFunction, MeasureFunction, Node, Yoga, } from '../wrapAssembly';
declare const Yoga: import("../wrapAssembly").Yoga;
export default Yoga;
